import { useState } from 'react'
import React from 'react'
import axios from 'axios'
import { Table, Tooltip } from 'antd'
import moment from 'moment'
import { useLocation, useNavigate } from 'react-router-dom'


export default function APP () {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [total, setTotal] = useState([])
  const pageSize = 10
  const fetchData = async (page) => {
    setLoading(true)
    const result = await axios(`/announcement/list?pageIndex=${page - 1}&pageSize=${pageSize}`)
    setLoading(false)
    setData(result.data.announcements)
    setTotal(result.data.total)
  }
  const navigate = useNavigate()
  const location = useLocation()
  React.useEffect(() => {
    if (!localStorage.getItem('logined')) {
      navigate('/?redirect=' + encodeURI(location.pathname))
    }
    const initPageIndex = 1
    fetchData(initPageIndex)
  }, [location, navigate])
  const handlePageChange = async page => {
    fetchData(page)
  }
  const paginationProps = {
    total, // 总条数
    pageSize, // 每页数据条数
    showTotal: () => (
      <span>总共{total}项</span>
    ),
    onChange: page => handlePageChange(page), //改变页码的函数
    hideOnSinglePage: false,
    showSizeChanger: false,
  }
  const columns = [
    {
      title: '时间',
      dataIndex: 'publishDate',
      render: text => (
        <Tooltip title={moment(text).format('YYYY-MM-DD HH:mm:ss')}>
          <span style={{color: text > moment().startOf('day').valueOf() ? 'inhert' : '#999'}}>{moment(text).format('HH:mm')}</span>
        </Tooltip>
      )
    },
    {
      title: '标题',
      dataIndex: 'title',
      render: (text, record) => (
        <Tooltip title={text}>
          <a href={record.url} target='_blank' rel="noreferrer">{text.substring(0, 50)}</a>
        </Tooltip>
      )
    },
    {
      title: '来源',
      dataIndex: 'src',
      render: (text, record) => (
        <Tooltip title={moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss')}>
          {text}
        </Tooltip>
      )
    }
  ]
  return (
    <Table
      loading={loading}
      columns={columns}
      dataSource={data}
      rowKey="id"
      pagination={paginationProps}
      expandable={{
        expandedRowRender: record => (
          <div style={{
            textAlign: 'left',
            background: record.src === '币安' ? '#181a20' : 'inhert'
          }} dangerouslySetInnerHTML={{ __html: record.content }}></div>
        ),
        rowExpandable: record => record.content !== null
      }}
    />
  )
}
